import { render, staticRenderFns } from "./ReviewPlant.vue?vue&type=template&id=272d02be&scoped=true&"
import script from "./ReviewPlant.vue?vue&type=script&lang=js&"
export * from "./ReviewPlant.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPlant.vue?vue&type=style&index=0&id=272d02be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d02be",
  null
  
)

export default component.exports